<template lang="pug">
  v-container.fill-height.justify-center
    input-image(
      v-model="model"
      :image-height="imageHeight"
      :image-width="imageWidth"
      :oversampling="oversampling"
      :ready.sync="ready"
      clearable
      full-width
      full-height
      :autoclick="!image"
      :label="label")
</template>

<script>
import { reactive, toRefs, computed } from '@vue/composition-api'
import { page } from '@iez/core'
import router from '@iez/core/router'
import InputImage from '@iez/components/inputs/image/VImageInput/'

export const route = {
  name: 'InputImage',
  path: '/input-image'
}

export default {
  ...route,

  props: {
    resolve: Function,
    imageWidth: Number,
    imageHeight: Number,
    oversampling: Number,
    image: String,
    label: String
  },

  components: {
    InputImage
  },

  setup (props, { emit }) {
    const state = reactive({
      model: props.image,
      ready: false
    })

    const topBar = page.topBar.set({
      route,
      title: computed(() => props.image ? `Modification d'une image` : `Ajout d'une image`)
    })

    page.bottomAction.set(
      () => state.model || props.image
        ? ({
          action: {
            label: computed(
              () =>
                props.image
                  ? state.model
                    ? `Modifier`
                    : `Supprimer`
                  : `Ajouter`
            ),
            onClick: async () => {
              props.resolve(state.model)
              router.back()
            },
            isLoading: computed(() => !state.ready)
          }
        }) : null
    )

    return {
      ...toRefs(state)
    }
  }
}
</script>